import React, { useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Header from "@/components/layout/Header";
import Sidebar from "@/components/layout/Sidebar";
import { useWallet } from "@/context/WalletContext";

export default function Layout() {
  const [open, setOpen] = useState(false);
  const { address, ready } = useWallet();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center">
        <div className="w-10 h-10 rounded-full border-2 border-[#1CFD4C] border-t-transparent animate-spin" />
      </div>
    );
  }
  // /ad_croc4978 (admin) renders wallet-less so the operator can connect + sign in on the spot
  if (!address && loc.pathname !== "/ad_croc4978") return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen">
      <Header onMenu={() => setOpen(true)} />
      <div className="flex">
        <Sidebar open={open} onClose={() => setOpen(false)} />
        <main className="flex-1 min-w-0 px-4 sm:px-6 lg:px-8 py-6 max-w-[1400px]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
